import Link from "next/link";
import { motion } from "framer-motion";
import { ImageComponent } from "../ui/image";
interface AlbumGridProps {
  items: Array<{
    id: number;
    url: string;
    category: string;
    image_url: string | null;
  }>;
  baseUrl: string;
}

export function AlbumGrid({ items, baseUrl }: AlbumGridProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
      {items.map((item, index) => (
        <motion.div
          key={item.id}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.05 }}
        >
          <Link href={`${baseUrl}/${item.url}`}>
            <div className="group bg-white rounded-lg overflow-hidden border border-gray-100 hover:shadow-md transition-all duration-300 hover:-translate-y-1">
              <div className="aspect-[16/9] relative bg-gray-50">
                <ImageComponent src={item.image_url} alt={item.category} fill aspectRatio="16/9" />
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-gray-800">{item.category}</h3>
              </div>
            </div>
          </Link>
        </motion.div>
      ))}
    </div>
  );
} 